module.exports = __webpack_public_path__ + "static/img/jacki.7bc9035.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jacki.png
// module id = 313
// module chunks = 180